import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bid-actions d-flex justify-space-between" }
const _hoisted_2 = { class: "d-flex align-center gap-3" }

import useBid from '@/composables/useBid';
import BidViewSaveAsDraft from './BidViewSaveAsDraft.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { IAsset } from '@/types/store';
import { RAW_ASSETS_STATUSES } from '@/constants/statuses';

// #interfaces
interface IProps {
  isDisabledForm: boolean;
}

// #props

export default /*@__PURE__*/_defineComponent({
  __name: 'BidViewActions',
  props: {
    isDisabledForm: { type: Boolean, default: false }
  },
  setup(__props: any) {



// #constants
const { getters, commit } = useStore();
const {
  onUpdateProposal,
  onDeleteProposal,
  onCreateProposal,
  onUpdateBid,
  closeModal,
  isLoading,
  isWithdrawLoading,
  proposalId,
  isProposal,
  proposalStatus
} = useBid();

// #computed
const asset = computed<IAsset>(() => {
  return getters['getAsset'];
});
const getStatus = computed<string>(() => {
  const { status } = asset.value ?? {};
  return status;
});
const isAuctionCancelled = computed<boolean>(() => {
  return getStatus.value === RAW_ASSETS_STATUSES.CANCELLED;
});
const isAuctionCompleted = computed<boolean>(() => {
  return getStatus.value === RAW_ASSETS_STATUSES.COMPLETED;
});
const isPaused = computed<boolean>(() => {
  // Don't show paused if auction is cancelled or completed
  if (isAuctionCancelled.value || isAuctionCompleted.value) {
    return false;
  }
  const { auction } = asset.value ?? {};
  return !!(auction as any)?.isPaused;
});
const isAuctionInactive = computed<boolean>(() => {
  return isPaused.value || isAuctionCancelled.value || isAuctionCompleted.value;
});
const getButtonValue = computed(() => {
  if (proposalStatus.value === 'draft') {
    return 'Submit';
  }
  return proposalId.value ? 'Update' : 'Submit';
});
const isDraftButtonNeed = computed<boolean>(() => {
  return proposalStatus.value === 'draft' || !proposalStatus.value;
});
const getPhaseValues = computed<(string | number)[]>(() => {
  return getters['getPhaseValues'];
});

// #methods
const validatePhaseValues = (): boolean => {
  const phaseValues = getPhaseValues.value;

  if (!phaseValues || phaseValues.length === 0) {
    return false;
  }

  // Check if all phase values are greater than 0
  const allValid = phaseValues.every((value) => {
    const numValue = Number(value);
    return numValue > 0 && !isNaN(numValue);
  });

  return allValid;
};

const onSubmit = () => {
  // Validate phase values before submission
  if (!validatePhaseValues()) {
    commit('errorNotification', {
      text: 'Invalid bid values',
      subtext:
        'All phase amounts must be greater than $0. Please review and update your bid values.',
      closable: true
    });
    return;
  }

  if (isProposal.value) {
    return proposalId.value
      ? onUpdateProposal('initial')
      : onCreateProposal('initial');
  }
  onUpdateBid();
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_btn, {
      variant: "text",
      class: "bid-actions__cancel",
      disabled: _unref(isLoading),
      onClick: _unref(closeModal)
    }, {
      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
        _createTextVNode("Cancel", -1)
      ]))]),
      _: 1
    }, 8, ["disabled", "onClick"]),
    _createElementVNode("div", _hoisted_2, [
      (_unref(isProposal) && isDraftButtonNeed.value)
        ? (_openBlock(), _createBlock(BidViewSaveAsDraft, {
            key: 0,
            disabled: _unref(isLoading) || __props.isDisabledForm || isAuctionInactive.value
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (_unref(proposalId))
        ? (_openBlock(), _createBlock(_component_v_btn, {
            key: 1,
            variant: "flat",
            disabled: _unref(isLoading) || __props.isDisabledForm || isAuctionInactive.value,
            loading: _unref(isWithdrawLoading),
            class: "bid-actions__withdraw",
            onClick: _unref(onDeleteProposal)
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Withdraw", -1)
            ]))]),
            _: 1
          }, 8, ["disabled", "loading", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_v_btn, {
        variant: "flat",
        disabled: __props.isDisabledForm || isAuctionInactive.value,
        loading: _unref(isLoading),
        class: "bid-actions__submit",
        onClick: onSubmit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(getButtonValue.value), 1)
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ])
  ]))
}
}

})